import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DialogTitle, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { User } from '~/modules/common/components';
import Project from '~/modules/common/components/Project/Project';

const useStyles = makeStyles(theme => ({
  container: {
    alignItems: 'center',
    columnGap: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  root: {
    padding: theme.spacing(1, 1, 1, 2)
  },
  text: {
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(0.125)
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    whiteSpace: 'nowrap'
  }
}));

const useProjectStyles = makeStyles(theme => ({
  container: {
    overflow: 'hidden',
    '& svg': {
      color: theme.palette.text.secondary
    }
  },
  label: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    paddingTop: theme.spacing(0.25)
  }
}));

const useUserStyles = makeStyles(theme => ({
  label: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    paddingTop: theme.spacing(0.25)
  }
}));

const SetResourceAllocationDialogTitle = ({ project, titleId, user }) => {
  const classes = useStyles();
  const projectClasses = useProjectStyles();
  const userClasses = useUserStyles();

  return (
    <DialogTitle className={classes.root} id={titleId}>
      <div className={classes.container}>
        <Typography className={classes.title} variant="h6">
          <FormattedMessage id="setResourceAllocationDialog.title" />
        </Typography>
        <User classes={userClasses} user={user} />
        <Typography className={classes.text} variant="body2">
          <FormattedMessage id="setResourceAllocationDialog.to" />
        </Typography>
        <Project classes={projectClasses} project={project} />
      </div>
    </DialogTitle>
  );
};

SetResourceAllocationDialogTitle.propTypes = {
  project: PropTypes.object,
  titleId: PropTypes.string.isRequired,
  user: PropTypes.object
};

export default SetResourceAllocationDialogTitle;
